import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, TablePagination
} from '@mui/material';

const List = () => {
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const authTokenStr = localStorage.getItem('auth_token_crm');
    const token = authTokenStr ? JSON.parse(authTokenStr)?.token : null;
    
    fetch(`${process.env.REACT_APP_SERVER_URI}/users/chats/list?page=${page + 1}&limit=${rowsPerPage}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then(res => res.json())
      .then(result => {
        console.log('Full API Response:', result);
        setChats(result.data || []);
        setTotal(result.total || 0);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching chats:', error);
        setChats([]);
        setTotal(0);
        setLoading(false);
      });
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString();
  };

  const handleUserNameClick = (userId, washerId, userName) => {
    navigate(`/chat/${userId}?washerId=${washerId}&userName=${userName}`);
  };

  console.log(chats, ' chats data');
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>Chat List</Typography>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>User Name</TableCell>
                <TableCell>User Phone</TableCell>
                <TableCell>Washer Name</TableCell>
                <TableCell>Car Model</TableCell>
                <TableCell>Car Reg No</TableCell>
                <TableCell>Messages</TableCell>
                <TableCell>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chats.map(chat => (
                <TableRow key={chat._id}>
                  <TableCell>
                    <Typography
                      component="span"
                      sx={{ 
                        color: 'primary.main', 
                        cursor: 'pointer', 
                        textDecoration: 'underline',
                        '&:hover': { color: 'primary.dark' }
                      }}
                      onClick={() => handleUserNameClick(chat.userId, chat.washerId, chat.userName)}
                    >
                      {chat.userName || '-'}
                    </Typography>
                  </TableCell>
                  <TableCell>{chat.userPhone || '-'}</TableCell>
                  <TableCell>{chat.washerName || '-'}</TableCell>
                  <TableCell>{chat.carModel || '-'}</TableCell>
                  <TableCell>{chat.carRegNo || '-'}</TableCell>
                  <TableCell>{chat.lastMessage?.message || '-'}</TableCell>
                  <TableCell>{formatDate(chat.createdAt)}</TableCell>
                </TableRow>
              ))}
              {chats.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} align="center">No chats found.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />
        </TableContainer>
      )}
    </Box>
  );
};

export default List;